type FormatBRLOptions = {
  fractionDigits?: number;
};

export function formatBRL(value: number, options?: FormatBRLOptions): string {
  const fractionDigits = options?.fractionDigits;

  return value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    ...(fractionDigits !== undefined && {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }),
  });
}
